/** @format */

const endpoint = {
    URL_SEND_CODE: "v5.0/code-new",
    // URL_GET_INFO: "v5.0/profile",
    URL_SIGNING_EMAIL: "v5.0/signin-email",
    URL_SINGUP_EMAIL: "v5.0/register",
    URL_SIGNIN_WITH_FB_GOOGLE: "v5.0/signin-with-social",
};
export default endpoint;
